import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
    IAttributeColumn,
    IDictionaryDetailedItems,
    IDictionaryForm,
} from '@models/dictionary/IDictionaryDetailedItems';
import { SLICE_NAMES } from '@/constants';

export interface IDictionaryState {
    kind?: 'dictionary' | 'formData' | 'sql';
    forms?: IDictionaryForm[];
    tmpFormDict?: string;
    rootDictionaryName: string;
    displayName: string;
    rootDictionaryId: string;
    isLoading: boolean;
    isFavorite: boolean;
    canView: boolean;
    canEdit: boolean;
    canDelete: boolean;
    canCreate: boolean;
    codeTitle?: string;
    nameTitle?: string;
    columns?: IAttributeColumn[];
    isPlainDict: boolean;
    hideNameColumn: boolean;
    hideCodeColumn: boolean;
}

const initialState: IDictionaryState = {
    kind: undefined,
    forms: undefined,
    tmpFormDict: undefined,
    isLoading: true,
    rootDictionaryName: '',
    displayName: '',
    rootDictionaryId: '',
    isFavorite: false,
    canView: false,
    canEdit: false,
    canDelete: false,
    canCreate: false,
    columns: undefined,
    isPlainDict: false,
    hideNameColumn: false,
    hideCodeColumn: false,
};

export const DictionarySlice = createSlice({
    name: SLICE_NAMES.DICTIONARY,
    initialState,
    reducers: {
        setIsLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
        setIsFavorite: (state, action: PayloadAction<boolean>) => {
            state.isFavorite = action.payload;
        },

        successLoadDictionaryScheme: (state, action: PayloadAction<IDictionaryDetailedItems>) => {
            state.kind = action.payload.kind ?? (action.payload.template ? 'formData' : 'dictionary');
            if (state.kind === 'formData') {
                state.tmpFormDict = action.payload.template;
                if (action.payload.dictionaryName) state.rootDictionaryName = action.payload.dictionaryName;
                else state.rootDictionaryName = '';
                state.forms = undefined;
            } else {
                state.tmpFormDict = '';
                state.rootDictionaryName = action.payload.dictionaryName;
                state.forms = action.payload.forms;
            }
            state.displayName = action.payload.displayName ?? '';
            state.rootDictionaryId = action.payload.dictionaryId;
            state.canView = action.payload.canView;
            state.canEdit = action.payload.canEdit;
            state.canDelete = action.payload.canDelete;
            state.canCreate = action.payload.canCreate;
            state.codeTitle = action.payload.codeTitle;
            state.nameTitle = action.payload.nameTitle;
            state.columns = action.payload.columns;
            state.isPlainDict = action.payload.isPlainDict;
            state.hideNameColumn = action.payload.hideNameColumn;
            state.hideCodeColumn = action.payload.hideCodeColumn;
        },

        reset: (state) => {
            state.kind = undefined;
            state.forms = undefined;
            state.tmpFormDict = undefined;
            state.isLoading = true;
            state.rootDictionaryName = '';
            state.displayName = '';
            state.rootDictionaryId = '';
            state.isFavorite = false;
            state.canView = false;
            state.canEdit = false;
            state.canDelete = false;
            state.canCreate = false;
            state.columns = undefined;
            state.hideNameColumn = false;
            state.hideCodeColumn = false;
        },
    },
});

export const { setIsLoading } = DictionarySlice.actions;

export default DictionarySlice.reducer;
